import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";
import { showSignInStateChangedInfoBar } from "./showSignInStateInfoBar";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "SignInStateChangedInfoBar" */ "./lazyIndex"), { name: "SignInStateChangedInfoBar" });

export const SignInStateChangedInfoBar: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.SignInStateChangedInfoBar, undefined, undefined, {
    onlyImportIf: () => showSignInStateChangedInfoBar(),
});
